var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 121,
    viewBox: "0 0 139 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_404_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.418 57.606L35.1835 10.4675C34.7139 9.71038 33.5634 9.89892 33.36 10.7663L12 101.882L61.1902 71.3749C65.8837 68.4641 67.3289 62.2995 64.418 57.606Z",
    stroke: "white",
    strokeWidth: 10,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6875 108.936C78.7248 109.405 76.3142 109.64 73.4555 109.64C70.5115 109.64 67.8662 108.915 65.5195 107.464C63.2155 105.971 61.4022 103.965 60.0795 101.448C58.7568 98.888 58.0955 96.072 58.0955 93C58.0955 89.672 59.1195 86.5787 61.1675 83.72C63.2582 80.8187 65.8608 78.5147 68.9755 76.808C72.0902 75.0587 75.0982 74.184 77.9995 74.184C82.2235 74.184 85.5088 75.8267 87.8555 79.112C90.2022 82.3973 91.3542 86.8133 91.3115 92.36H67.8235C68.1648 95.6027 69.1248 98.2267 70.7035 100.232C72.3248 102.237 74.5008 103.24 77.2315 103.24C80.0902 103.24 84.1862 101.341 89.5195 97.544L91.3755 100.488L80.6875 108.936ZM74.3515 80.328C70.1275 80.328 67.9088 83.2507 67.6955 89.096H81.5835C81.2422 87.0053 80.8582 85.384 80.4315 84.232C80.0475 83.0373 79.3648 82.0987 78.3835 81.416C77.4448 80.6907 76.1008 80.328 74.3515 80.328ZM134.089 77.448L117.769 109H111.625L101.833 85.128L95.7525 81.608V78.984L107.977 73.608L110.409 83.272L117.897 101.512L126.409 84.232L117.577 78.024L119.177 74.824H134.089V77.448Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_404_548",
    x: 0.376953,
    y: 4.99219,
    width: 74.5449,
    height: 115.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_404_548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_404_548",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f57eceb71fdb4334c1e3f647e1b30f49.svg";
export { ForwardRef as ReactComponent };